import type { UiRoot } from "../ui/UiRoot";
import type { Scene } from "./Scene";

export class CharacterScene implements Scene {
  readonly id = "character" as const;
  constructor(private readonly ui: UiRoot) {}
  enter(): void {
    this.ui.hideHud();
    this.ui.show("character");
  }
  exit(): void {}
}
